export default "__VITE_ASSET__DjotXG3b__"